import { render, staticRenderFns } from "./ReservedLogTabs.vue?vue&type=template&id=236bc06b&lang=pug"
import script from "./ReservedLogTabs.vue?vue&type=script&lang=js"
export * from "./ReservedLogTabs.vue?vue&type=script&lang=js"
import style0 from "./ReservedLogTabs.vue?vue&type=style&index=0&id=236bc06b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports